import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import apiClient from '../../Api/axiosConfig';
import './AdminLogin.css';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { login, isLoggedIn } = useAuth();

  useEffect(() => {
    if (isLoggedIn === true) {
      navigate('/admin');
    }
  }, [isLoggedIn, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await apiClient.post('/auth/login', { username, password });
      login();
      navigate('/admin');
    } catch (err) {
      setError('Hibás felhasználónév vagy jelszó.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoggedIn === null) {
      return <div className="loading-container">Hitelesítés...</div>
  }

  return (
    <div className="login-container">
      <div className="login-form-wrapper">
        <h1 className="login-title">ADMIN BELÉPÉS</h1>
        <form className="login-form" onSubmit={handleSubmit}>
          <input 
            type="text" 
            placeholder="Felhasználónév" 
            value={username} 
            onChange={e => setUsername(e.target.value)} 
            required 
          />
          <input 
            type="password" 
            placeholder="Jelszó" 
            value={password} 
            onChange={e => setPassword(e.target.value)} 
            required 
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? 'Hitelesítés...' : 'Belépés'}
          </button>
          {error && <p className="error-message">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;